module.exports = __webpack_public_path__ + "img/GALLERY-VITARA-1.9631296e.jpg";